module.exports = __webpack_public_path__ + "images/home_pic_left-cac5c88ffc.png";